import type { ForecastingRow } from '@/api/forecasting';
import { isDynamicForecastStage } from './dynamicForecastMetrics';
import { parseMetricNumber } from './forecastingNumbers';
import { isBookedStatus, isPipeStatus } from './monthlyStageRules';

function isPrePipeStatus(status?: string): boolean {
  if (isPipeStatus(status) || isBookedStatus(status)) return false;
  const t = status?.trim().toLowerCase() ?? '';
  if (!t) return false;
  if (t.includes('pre') && t.includes('pipe')) return true;
  const pct = t.match(/^(\d+)%/);
  if (pct) {
    const n = Number(pct[1]);
    return n > 0 && n < 70;
  }
  return false;
}

export function rowWeight(row: ForecastingRow): number {
  if (row.Revenue_Weighting == null || row.Revenue_Weighting === '') return 1;
  const n = parseMetricNumber(row.Revenue_Weighting);
  if (n === 0) return 0;
  if (n === 1) return 1;
  return n > 0 ? 1 : 0;
}

/* Booked is booked whatever the month or year: counted on Status alone. The
   compiled sheet labels Forecast_Stage by how far out a month is -- booked
   rows are "Dynamic Forecast" this month and next, but "Booked" beyond that
   -- so gating on the stage dropped every booking two or more months out
   (Dec 2026 showed nothing booked in October). Pipe and the dynamic forecast
   keep the stage rule: that is where it means what it says. */
export function bookedRevenue(row: ForecastingRow): number {
  if (!isBookedStatus(row.Status)) return 0;
  return parseMetricNumber(row.Net_Rev__Rec_) * rowWeight(row);
}

export function pipeRevenue(row: ForecastingRow): number {
  if (!isDynamicForecastStage(row.Forecast_Stage)) return 0;
  if (!isPipeStatus(row.Status)) return 0;
  return parseMetricNumber(row.Net_Rev__Rec_) * rowWeight(row);
}

export function prePipeRevenue(row: ForecastingRow): number {
  if (!isDynamicForecastStage(row.Forecast_Stage)) return 0;
  if (!isPrePipeStatus(row.Status)) return 0;
  return parseMetricNumber(row.Net_Rev__Rec_) * rowWeight(row);
}
